import request from '../request';

const getOrderLines = (id) => request({
  url: `/order-info/line?id=${id}`,
  method: 'GET',
  headers: {},
});

export default getOrderLines;
